import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { access } from './schemas/common.js';
import { questionStatsSchema, seriesPointSchema, sourceHealthSchema, totalsSchema, } from './schemas/domain.js';
const c = initContract();
/** Every chart is bounded by a window, and 90 days is as far back as one asks. */
const windowQuery = z.object({
    days: z.coerce.number().int().min(1).max(90).default(30),
});
export const analyticsContract = c.router({
    overview: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/analytics/overview',
        summary: 'Totals and the health of every configured source',
        responses: {
            200: z.object({ totals: totalsSchema, sources: z.array(sourceHealthSchema) }),
        },
    },
    records: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/analytics/records',
        summary: 'Records per UTC day, grouped by kind or by source',
        query: windowQuery.extend({ groupBy: z.enum(['kind', 'source']).default('kind') }),
        responses: { 200: z.object({ points: z.array(seriesPointSchema) }) },
    },
    questions: {
        method: 'GET',
        metadata: access('viewer'),
        path: '/analytics/questions',
        summary: 'How many questions were asked, and what they cost',
        query: windowQuery,
        responses: { 200: questionStatsSchema },
    },
});
//# sourceMappingURL=analytics.contract.js.map